// extracted by mini-css-extract-plugin
export default {"wrapper":"list-items-pagination_wrapper__cc5V9"};